<template>
  <div class="tab-scroll-container w-full flex flex-row align-center">
    <!-- 左侧滚动按钮 -->
    <el-button
      icon="el-icon-arrow-left"
      size="mini"
      class="scroll-btn left-btn"
      @click="handleScroll(-1)"
    />

    <!-- 标签容器（支持拖拽） -->
    <div
      ref="scrollWrap"
      class="scroll-wrap"
      :class="{ 'is-dragging': isDragging }"
      @scroll="handleWrapScroll"
      @mousedown="startDragging"
      @mouseleave="stopDragging"
      @mouseup="stopDragging"
    >
      <div class="tab-list">
        <slot />
      </div>
    </div>

    <!-- 右侧滚动按钮 -->
    <el-button
      icon="el-icon-arrow-right"
      circle
      size="mini"
      class="scroll-btn right-btn"
      @click="handleScroll(1)"
    />
  </div>
</template>

<script>
export default {
  name: "TabScroll",
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    scrollStep: {
      type: Number,
      default: 50 // 点击按钮的滚动步长
    },
    dragSensitivity: {
      type: Number,
      default: 1.5 // 拖拽灵敏度系数
    }
  },
  data() {
    return {
      tabList: this.tabs,
      isDragging: false,
      startX: 0,
      startScrollLeft: 0
    }
  },
  computed: {
    canScrollLeft() {
      const wrap = this.$refs.scrollWrap
      return wrap ? wrap.scrollLeft > 1 : false
    },
    canScrollRight() {
      const wrap = this.$refs.scrollWrap
      if (!wrap) return false
      return wrap.scrollLeft + wrap.clientWidth < wrap.scrollWidth - 1
    }
  },
  watch: {
    tabs(newVal) {
      this.tabList = newVal
    }
  },
  beforeDestroy() {
    // 确保组件销毁时移除全局事件监听
    document.removeEventListener('mousemove', this.onDrag)
    document.removeEventListener('mouseup', this.stopDragging)
  },
  methods: {
    // 开始拖拽
    startDragging(e) {
      if (!this.$refs.scrollWrap) return

      // 阻止默认行为和冒泡（避免选中文字）
      e.preventDefault()

      this.isDragging = true
      this.startX = e.pageX
      this.startScrollLeft = this.$refs.scrollWrap.scrollLeft

      // 添加全局鼠标移动和抬起事件
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.stopDragging)

      // 改变光标样式
      this.$refs.scrollWrap.style.cursor = 'grabbing'
    },

    // 拖拽过程中
    onDrag(e) {
      if (!this.isDragging) return

      const deltaX = e.pageX - this.startX
      const wrap = this.$refs.scrollWrap

      // 根据鼠标移动距离计算滚动量（乘以灵敏度系数）
      wrap.scrollLeft = this.startScrollLeft - (deltaX * this.dragSensitivity)
    },

    // 停止拖拽
    stopDragging() {
      this.isDragging = false

      // 移除全局事件监听
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.stopDragging)

      // 恢复光标样式
      if (this.$refs.scrollWrap) {
        this.$refs.scrollWrap.style.cursor = ''
      }
    },

    // 容器滚动时触发，更新按钮状态
    handleWrapScroll() {
      // 可添加节流逻辑
    },

    // 点击左右按钮滚动
    handleScroll(direction) {
      const wrap = this.$refs.scrollWrap
      if (!wrap) return
      wrap.scrollLeft += direction * this.scrollStep
    },

    // 关闭标签
    handleClose(tab) {
      this.$emit("close", tab)
      this.tabList = this.tabList.filter((item) => item !== tab)
    }
  }
}
</script>

<style scoped>
.tab-scroll-container {
  display: flex;
  align-items: center;
  border-radius: 4px;
  overflow: hidden;
  transition: all .5s;
  margin-bottom: 4px;
}

.scroll-wrap {
  flex: 1;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  cursor: grab; /* 默认光标样式 */
  transition: all .5s;
}
.scroll-wrap::-webkit-scrollbar {
  display: none;
  transition: all .5s;
}
.scroll-wrap.is-dragging {
  cursor: grabbing; /* 拖拽时光标样式 */
  transition: all .5s;
}

.tab-list {
  display: flex;
  gap: 8px;
  white-space: nowrap;
  transition: all .5s;
}

.scroll-btn {
  width: 32px;
  height: 32px;
  background: #FFFFFF;
  border-radius: 4px 4px 4px 4px;
  padding: 9px;
  border-color: transparent;
}
.scroll-btn:hover {
  color: #409eff;
  transition: all .5s;
}
.left-btn {
  margin-right: 4px;
}
.right-btn {
  margin-left: 4px;
}

.tab-item {
  cursor: pointer;
  transition: all .5s;
}
</style>
